document.addEventListener("DOMContentLoaded", () => {
  const printSelect = document.getElementById("PrintSides");
  const backWrap = document.getElementById("BackUploadWrap");
  const placementSelect = document.getElementById("OneSidedPlacement");
  const addonVariantIdEl = document.getElementById("AddonVariantId");

  // Uploadcare widgets (front/back)
  const frontWidgetEl = document.getElementById("UploadcareWidgetFront");
  const backWidgetEl = document.getElementById("UploadcareWidgetBack");
  const frontProp = document.getElementById("UploadcareCdnUrlFront");
  const backProp = document.getElementById("UploadcareCdnUrlBack");

  function toggleBack() {
  const twoSided = printSelect && printSelect.value === "2";

  const placementSelectWrap = document.getElementById("OneSidedPlacement")?.closest(".select");
  const frontUploadLabel = document.querySelector('label[for="UploadcareWidgetFront"]');

  if (twoSided) {
    // Show back upload
    if (backWrap) backWrap.style.display = "block";

    // Hide placement dropdown
    if (placementSelectWrap) placementSelectWrap.style.display = "none";

    // Change first upload label
    if (frontUploadLabel) frontUploadLabel.textContent = "Front print file";
  } else {
    // Hide back upload
    if (backWrap) backWrap.style.display = "none";

    // Show placement dropdown
    if (placementSelectWrap) placementSelectWrap.style.display = "";

    // Reset first upload label
    if (frontUploadLabel) frontUploadLabel.textContent = "Customize! (Front OR Back)";

    if (backProp) backProp.value = "";
  }
}

  if (printSelect) {
    printSelect.addEventListener("change", toggleBack);
    toggleBack();
  }

  // Hook Uploadcare -> hidden properties
  if (window.uploadcare) {
    if (frontWidgetEl && frontProp) {
      const frontWidget = uploadcare.Widget(frontWidgetEl);
      frontWidget.onUploadComplete((fileInfo) => (frontProp.value = fileInfo.cdnUrl));
      frontWidget.onChange((file) => {
        if (!file) frontProp.value = "";
      });
    }

    if (backWidgetEl && backProp) {
      const backWidget = uploadcare.Widget(backWidgetEl);
      backWidget.onUploadComplete((fileInfo) => (backProp.value = fileInfo.cdnUrl));
      backWidget.onChange((file) => {
        if (!file) backProp.value = "";
      });
    }
  }

  // Add-on logic: add both items to cart together
  document.addEventListener("submit", async (e) => {
    const form = e.target;
    if (!form || !form.matches('form[action^="/cart/add"]')) return;

    // Only act if 2-sided selected
    if (!printSelect || printSelect.value !== "2") return;

    const addonVariantId = addonVariantIdEl ? addonVariantIdEl.value : "";
    if (!addonVariantId) return;

    // Basic validation: ensure files exist
    if (!frontProp || !frontProp.value) {
      e.preventDefault();
      alert("Please upload your print file first.");
      return;
    }
    if (!backProp || !backProp.value) {
      e.preventDefault();
      alert("Please upload the BACK print file for 2-sided printing.");
      return;
    }

    // We will replace Dawn submit with a combined add-to-cart (2 items)
    e.preventDefault();

    // Collect the selected main variant + qty
    const fd = new FormData(form);
    const mainVariantId = fd.get("id");
    const qty = parseInt(fd.get("quantity") || "1", 10);

    // Collect existing line item properties from the form
    const properties = {};
    for (const [k, v] of fd.entries()) {
      if (k.startsWith("properties[")) {
        const name = k.slice(11, -1); // properties[...]
        properties[name] = v;
      }
    }

    // For 2-sided, force clarity in properties
    properties["Print"] = "2-sided (+$3)";
    properties["1-sided placement"] = ""; // not relevant for 2-sided

    const payload = {
      items: [
        {
          id: Number(mainVariantId),
          quantity: qty,
          properties
        },
        {
          id: Number(addonVariantId),
          quantity: qty,
          properties: {
            "Add-on": "2-sided print (+$3)",
            "Linked product": window.location.pathname
          }
        }
      ]
    };

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload)
      });

      if (!res.ok) throw new Error("Add to cart failed");

      // Redirect to cart (safe + works with any theme setup)
      window.location.href = "/cart";
    } catch (err) {
      console.error(err);
      alert("Something went wrong adding the 2-sided add-on. Please try again.");
    }
  });
});